import {ApexOptions} from 'apexcharts'
import ReactApexChart from 'react-apexcharts'
import Spinner from 'react-bootstrap/esm/Spinner'
import {getDateForChart} from 'src/feature/bite/helpers/date'

export default function LineAreaChart({
  data: {series, categories},
  isLoading = false,
}: {
  data: {
    series: {name: string; data: number[]}[]
    categories: string[]
  }
  isLoading?: boolean
}) {
  const options: ApexOptions = {
    chart: {
      type: 'area',
      width: '100%',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    fill: {
      colors: ['#02acd2'],
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.5,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 0,
        stops: [0, 100],
        colorStops: [],
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      colors: ['#02acd2'],
    },
    yaxis: {
      opposite: true,
      show: false,
      labels: {
        show: true,
        formatter: (value: number) => {
          return value?.toFixed(0)
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    xaxis: {
      // type: 'datetime',
      type: 'category',
      tickPlacement: 'between',
      tickAmount: 'dataPoints',
      // tickPlacement: series[0].data.length === 1 ? 'on' : 'between',
      // tickAmount: series[0].data.length === 1 ? 1 : 'dataPoints',
      // range: series[0].data.length + 1,
      labels: {
        show: true,
        formatter: (value: string) => {
          return getDateForChart(value)
        },
        offsetX: 0,
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      categories,
    },
    // tooltip: {
    //   // enabled: false,
    //   x: {
    //     format: 'dd/MM/yy HH:mm',
    //   },
    // },
  }

  if (isLoading) {
    return (
      <div style={{height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Spinner animation='border' />
      </div>
    )
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      height={250}
      type='area'
      style={
        {
          /* width: '100%',
        position: 'absolute',
        minHeight: '100% !important',
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'end',
        padding: 0,
        margin: 0,
        bottom: 0,
        left: 0,
        zIndex: 0, */
        }
      }
    />
  )
}
